export default {
    topMenuList: [
        { index: "1", name: "搜索引擎", path: "/SearchEngine" },
        { index: "2", name: "情报领域", path: "/IntelligenceField" },
        { index: "3", name: "俄乌冲突", path: "/newpage" },
        { index: "4", name: "二十大", path: "/Meet20" },
        { index: "5", name: "网络安全知识图谱", path: "/KnowledgeGraph" },
        { index: "6", name: "知识抽取", path: "/KnowledgeExtraction"},
        // { index: "5", name: "网络安全图谱管理", path: "/networkManagement" },
    ],
    secondaryMenuList: [
        { index: "1", name: "新闻", path: "/News" },
        { index: "2", name: "全球态势", path: "/GlobalSituation" },
        { index: "3", name: "国内态势", path: "/DomesticSituation" },
        { index: "4", name: "信息对比", path: "/InformationContrast" },
        { index: "5", name: "领域热词", path: "/DomainHotWords" },
    ]
}